exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\r\n.odd {\r\n    background-color: aliceblue;  \r\n}\r\n\r\n.title {\r\n    height: 50px;\r\n    vertical-align: middle;\r\n}\r\n\r\n.top-con {\r\n    height: 50px;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/components/Customer/customerList.component.css
// module id = 442
// module chunks = 1